import showdown from 'showdown';
var markdownToHtml = function markdownToHtml(markdown) {
  var options = {
    simpleLineBreaks: true,
    tasklists: true
  };
  var converter = new showdown.Converter(options);
  return converter.makeHtml(markdown);
};
export default markdownToHtml;